// extracted by mini-css-extract-plugin
export var accordion = "_gi-0";
export var chevron = "_gi-3";
export var closed = "_gi-2";
export var content = "_gi-4";
export var open = "_gi-1";
export var rotate = "_gi-5";